import React from 'react';
import { Calendar, User, Clock, ArrowLeft, ArrowRight } from 'lucide-react';
interface BOMVersionHistoryProps {
  selectedVersion: string;
}
export function BOMVersionHistory({
  selectedVersion
}: BOMVersionHistoryProps) {
  const versions = [{
    version: 'v2.1',
    date: 'June 15, 2021',
    author: 'Sarah Johnson',
    changes: 'Updated cork supplier to Amorim Cork',
    status: 'active'
  }, {
    version: 'v2.0',
    date: 'May 30, 2021',
    author: 'Michael Chen',
    changes: 'Changed label design, updated aging details',
    status: 'previous'
  }, {
    version: 'v1.3',
    date: 'April 12, 2021',
    author: 'Sarah Johnson',
    changes: 'Adjusted grape percentages',
    status: 'previous'
  }];
  return <div className="bg-white rounded-lg border" data-id="element-148">
      <div className="p-6 border-b border-gray-200" data-id="element-149">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-150">Version History</h2>
      </div>
      <div className="divide-y divide-gray-200" data-id="element-151">
        {versions.map(version => <div key={version.version} className={`p-4 ${version.version === selectedVersion ? 'bg-purple-50' : ''}`} data-id="element-152">
            <div className="flex items-center justify-between" data-id="element-153">
              <div className="flex items-center space-x-2" data-id="element-154">
                <span className={`font-medium ${version.version === selectedVersion ? 'text-purple-600' : 'text-gray-900'}`} data-id="element-155">
                  {version.version}
                </span>
                {version.status === 'active' && <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-156">
                    Active
                  </span>}
              </div>
              {version.version !== selectedVersion && <button className="text-sm text-purple-600 hover:text-purple-700" data-id="element-157">
                  View
                </button>}
            </div>
            <div className="mt-2 space-y-1 text-sm" data-id="element-158">
              <div className="flex items-center text-gray-500" data-id="element-159">
                <Calendar className="w-4 h-4 mr-2" data-id="element-160" />
                {version.date}
              </div>
              <div className="flex items-center text-gray-500" data-id="element-161">
                <User className="w-4 h-4 mr-2" data-id="element-162" />
                {version.author}
              </div>
              <div className="text-gray-600 mt-1" data-id="element-163">{version.changes}</div>
            </div>
          </div>)}
      </div>
      <div className="p-4 border-t border-gray-200 bg-gray-50 text-xs text-gray-500" data-id="element-164">
        BOM version control managed by TypeShift
      </div>
    </div>;
}